import React from 'react';
import ReactDOM from 'react-dom/client';
// React 19 + antd v5 兼容补丁：修复 Modal.confirm/message 等静态方法静默失效
import '@ant-design/v5-patch-for-react-19';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
